import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Button } from 'ui';

const PreviewButton = ({ previewPath, lessonId, disabled }) => {
  return (
    <Button
      disabled={disabled}
      url={previewPath}
      target={`lesson_preview_${lessonId}`}
      className="trk_button_readiness_preview-lesson"
    >
      {t('lessons.editor.preview')}
    </Button>
  );
};

const mapStateToProps = ({ editor }) => ({
  previewPath: get(editor.currentSection, 'preview_path'),
  lessonId: editor.lessonId,
});

export default connect(mapStateToProps)(PreviewButton);
